import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OfferPaymentPlanScheduleParamsRowComponent from './OfferPaymentPlanScheduleParamsRowComponent';
import { Autocomplete, Button } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

export const OfferPaymentPlanScheduleParamsComponent = ({
  scheduleTypeParams,
  onChangeScheduleParamType,
  scheduleParamTypeId,
  list,
  onSave,
  saving,
  onPropertyChange,
  validationScheduleParam,
  dirtyInfo,
  onDelete
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container mb={1}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            id={'scheduleParamsCard_ScheduleTypeParams'}
            disabled={false}
            fullWidth
            label={t('OfferEdit.ScheduleParams.Label')}
            labelKey='typeParamDisplayName'
            value={scheduleParamTypeId || null}
            valueKey='scheduleTypeParamId'
            options={scheduleTypeParams}
            isClearable={true}
            simpleValue={true}
            onChange={onChangeScheduleParamType}
          />
        </Grid>
      </Grid>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>{t('OfferEdit.ScheduleParams.ScheduleName')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('OfferEdit.ScheduleParams.ScheduleValue')}</strong>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list?.map((item, idx) => {
            return (
              <OfferPaymentPlanScheduleParamsRowComponent
                key={item.scheduleTypeParamId}
                idx={idx}
                item={item}
                onPropertyChange={onPropertyChange}
                validationScheduleParam={validationScheduleParam}
                onDelete={onDelete}
              />
            );
          })}
        </TableBody>
      </Table>
      <BoxActionsWrapper mt={2}>
        <Button id={'offerPaymentPlanAdvanceSplitCard_saveBtn'} onClick={onSave} disabled={saving || !dirtyInfo.documentScheduleParams}>
          {saving ? t('Saving') : t('Save')}
        </Button>
      </BoxActionsWrapper>
    </>
  );
};

OfferPaymentPlanScheduleParamsComponent.propTypes = {
  scheduleTypeParams: PropTypes.array.isRequired,
  onChangeScheduleParamType: PropTypes.func.isRequired,
  scheduleParamTypeId: PropTypes.number,
  list: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validationScheduleParam: PropTypes.object.isRequired,
  dirtyInfo: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default OfferPaymentPlanScheduleParamsComponent;
